export default __webpack_public_path__ + "static/media/file-drawer.e7948569.png";